import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import Axios from "axios";
import moment from "moment";
import { SwalError } from "../../../../utils/constants";
import {
  create,
  getAll,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { ROUTES } from "../../../../utils/routes";
import Swal from "sweetalert2";
import { paths } from "../../../../utils/paths";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { validate } from "./validations";
import { ArchiveUploader } from "../../../../components/FileUploader/ArchiveUploader";

export const ManageLibros = () => {
  const { LIBROS, SERIELIBROS, INVESTIGATORS } = paths;
  const { id } = useParams();
  const { deleteIt } = useDelete();

  let { staffId, isAdmin } = useSelector(({ user }) => user);

  const history = useHistory();

  const [isCreate, setIsCreate] = useState(false);

  const [titulo, setTitulo] = useState("");
  const [estado, setEstado] = useState("");
  const [motivoBaja, setMotivoBaja] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [soporte, setSoporte] = useState("");
  const [difusion, setDifusion] = useState("");
  const [adquisicion, setAdquisicion] = useState("");
  const [autor, setAutor] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [bibMaterias, setBibMaterias] = useState("");
  const [url, setUrl] = useState("");
  const [signatura, setSignatura] = useState("");
  const [numeroRegistro, setNumeroRegistro] = useState("");
  const [isbn, setIsbn] = useState("");
  const [fechaPrestamo, setFechaPrestamo] = useState("");
  const [anyo, setAnyo] = useState("");
  const [archivoBiblioteca, setArchivoBiblioteca] = useState("");
  const [serieLibros, setSerieLibros] = useState([]);
  const [serieLibroId, setSerieLibroId] = useState("");
  const [staff, setStaff] = useState([]);
  const [usuarioPrestamoId, setUsuarioPrestamoId] = useState("");
  const [idioma, setIdioma] = useState("");
  const [usuarioPrestamoEmail, setUsuarioPrestamoEmail] = useState("");

  const [message, setMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMountedRef.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? setIsCreate(true) : loadData();
    loadStaticData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadStaticData = async () => {
    try {
      let staff = isAdmin
        ? await getAll(INVESTIGATORS, source)
        : await getAll(INVESTIGATORS, source);
      let serieLibros = await getAll(SERIELIBROS, source);
      isMountedRef.current && isAdmin ? setStaff(staff) : setStaff(staff);
      setSerieLibros(serieLibros);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const loadData = async () => {
    try {
      let response = await getById(LIBROS, id, source);
      isMountedRef.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const buildObjToLoad = async (response) => {
    let allStaff = isAdmin
      ? await getAll(INVESTIGATORS, source)
      : await getAll(INVESTIGATORS, source);
    let allSerieLibros = await getAll(SERIELIBROS, source);
    const startDateWithOffset =
      response.fechaPrestamo && new Date(response.fechaPrestamo);
    const startDateNoOffset =
      startDateWithOffset &&
      new Date(
        startDateWithOffset.getTime() -
          startDateWithOffset.getTimezoneOffset() * -60000
      );
    const {
      titulo,
      estado,
      archivoBiblioteca,
      motivoBaja,
      tipoDocumento,
      difusion,
      soporte,
      adquisicion,
      autor,
      idioma,
      ciudad,
      anyo,
      bibMaterias,
      url,
      signatura,
      numeroRegistro,
      isbn,
    } = response;

    setTitulo(titulo);
    setEstado(estado);
    setMotivoBaja(motivoBaja);
    setTipoDocumento(tipoDocumento);
    setDifusion(difusion);
    setFechaPrestamo(startDateNoOffset);
    setSoporte(soporte);
    setAdquisicion(adquisicion);
    setAutor(autor);
    setIdioma(idioma);
    setArchivoBiblioteca(archivoBiblioteca);
    setCiudad(ciudad);
    setAnyo(anyo);
    setBibMaterias(bibMaterias);
    setUrl(url);
    setSignatura(signatura);
    setNumeroRegistro(numeroRegistro);
    setIsbn(isbn);
    setSerieLibros(allSerieLibros);
    setSerieLibroId(response.serieLibro?.id);

    isAdmin ? setStaff(allStaff) : setStaff(allStaff);
    setUsuarioPrestamoId(response.usuarioPrestamo?.id);
    const aux = await getById(
      INVESTIGATORS,
      response.usuarioPrestamo?.id,
      source
    );
    setUsuarioPrestamoEmail(aux?.email_personal);
    if (isMountedRef.current) setAllowedEdit(true);
  };

  const handleSubmit = () => {
    const libros = build();
    // const notValid = validate(libro);
    // if (notValid) {
    //   setMessage(notValid);
    //   setTimeout(() => setMessage(""), 4000);
    //   return;
    // }
    let question = isCreate ? "crear una" : "editar esta";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} libro?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed && handleConfirmation(libros);
    });
  };

  const handleConfirmation = (libros) => {
    let createOrUpdate = isCreate
      ? create(LIBROS, libros, source)
      : update(LIBROS, id, libros, source);
    createOrUpdate
      .then(async ({ id }) => {
        if (typeof archivoBiblioteca !== "string") {
          const formData = new FormData();
          formData.append("document", archivoBiblioteca);
          await saveFile(LIBROS, id, "archivo-biblioteca", formData, source);
        }
        Swal.fire({
          icon: "success",
          text: `Libro ${isCreate ? "creado" : "editado"} correctamente.`,
        });
        history.push(`${ROUTES.Biblioteca.all}`);
        setIsCreate(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: SwalError,
        });
      });
  };

  const build = () => ({
    titulo,
    estado,
    motivoBaja,
    tipoDocumento,
    difusion,
    fechaPrestamo: moment(fechaPrestamo).format("YYYY-MM-DD"),
    soporte,
    adquisicion,
    autor,
    idioma,
    ciudad,
    anyo,
    bibMaterias,
    url,
    signatura,
    numeroRegistro,
    isbn,
    serieLibroId: +serieLibroId,
    usuarioPrestamoId: +usuarioPrestamoId,
  });

  const exists = isAdmin
    ? staff.some((c) => c.id === usuarioPrestamoId)
    : staff.some((c) => c.id === usuarioPrestamoId);

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Libro
        </button>
      );
    }
    if (!isCreate || isAdmin) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-danger ml-1"
            onClick={() => deleteIt(LIBROS, id, ROUTES.Biblioteca.all, source)}
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    }
  };

  return (
    <div className="centerPage">
      <div className="container-fluid p-4">
        <div className="row">
          <div className="col d-flex justify-summary-between">
            <div>
              <h3>Libros </h3>
            </div>
          </div>
          {<div>{editDeleteButtons()}</div>}
        </div>
        <div className="row mt-4">
          <div className="col-12 text-center text-danger">
            <span>{message}</span>
          </div>
        </div>

        <div className="form-row mt-2">
          <div className="col">
            <small>*Título</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Título"
              value={titulo}
              onChange={({ target: { value } }) => {
                setTitulo(value);
              }}
              readOnly={!isAdmin}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col-6">
            {!isCreate || exists ? (
              <>
                <small>*Usuario préstamo</small>
                <select
                  className="form-control input"
                  value={usuarioPrestamoId}
                  onChange={({ target: { value } }) => {
                    setUsuarioPrestamoId(value);
                  }}
                >
                  <option value={null}>Disponible</option>
                  {staff?.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nombre} {c.apellidos}
                    </option>
                  ))}
                </select>
                {usuarioPrestamoEmail && (
                  <div className="form-row mt-2 ml-2">
                    <a
                      href={`mailto:${usuarioPrestamoEmail}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Enviar un email a: {usuarioPrestamoEmail}
                    </a>
                  </div>
                )}
              </>
            ) : (
              <></>
            )}
          </div>
          {!isCreate && (
            <div className="col">
              <span>Fecha de préstamo</span>
              <DatePicker
                className="form-control input"
                placeholderText="*Fecha de préstamo"
                selected={fechaPrestamo}
                onChange={(date) => setFechaPrestamo(date)}
                dateFormat="dd MMMM, yyyy"
                isClearable={allowedEdit}
                locale="es"
              />
            </div>
          )}
        </div>
        <div className="form-row mt-2">
          <div className="col   justify-content-center">
            <ArchiveUploader
              handleFile={isAdmin ? setArchivoBiblioteca : ""}
              archive={archivoBiblioteca}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          {!isCreate && (
            <div className="col">
              <small>Motivo baja</small>
              <select
                className="form-control input"
                value={motivoBaja}
                onChange={({ target: { value } }) => {
                  setMotivoBaja(value);
                }}
                disabled={!isAdmin}
              >
                <option value="">Seleccione una opción</option>
                <option value="Dañado">Dañado</option>
                <option value="Obsolescencia">Obsolescencia</option>
                <option value="Duplicidad">Duplicidad</option>
                <option value="Perdida_O_Robo">Pérdida o robo 2</option>
                <option value="No_Utilizacion">No utilización</option>
              </select>
            </div>
          )}
          <div className="col">
            <small>Difusión</small>
            <select
              className="form-control input"
              value={difusion}
              onChange={({ target: { value } }) => {
                setDifusion(value);
              }}
              disabled={!isAdmin}
            >
              <option value="">Seleccione una opción</option>
              <option value="Externa">Externa</option>
              <option value="Interna">Interna</option>
            </select>
          </div>
          <div className="col">
            <small>Soporte</small>
            <select
              className="form-control input"
              value={soporte}
              onChange={({ target: { value } }) => {
                setSoporte(value);
              }}
              disabled={!isAdmin}
            >
              <option value="">Seleccione una opción</option>
              <option value="Papel">Papel </option>
              <option value="Digital">Digital</option>
              <option value="PDF">PDF </option>
              <option value="CD">CD </option>
              <option value="Otros">Otros </option>
            </select>
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Adquisición</small>
            <select
              className="form-control input"
              value={adquisicion}
              onChange={({ target: { value } }) => {
                setAdquisicion(value);
              }}
              disabled={!isAdmin}
            >
              <option value="">Seleccione una opción</option>
              <option value="opcion1">Opción 1</option>
              <option value="opcion2">Opción 2</option>
              <option value="opcion3">Opción 3</option>
            </select>
          </div>
          <div className="col">
            <small>Autor</small>
            <input
              type="text"
              className="form-control"
              placeholder="Autor"
              value={autor}
              onChange={({ target: { value } }) => {
                setAutor(value);
              }}
              readOnly={!isAdmin}
            />
          </div>
          <div className="col">
            <small>Idioma</small>
            <select
              className="form-control input"
              value={idioma}
              onChange={({ target: { value } }) => {
                setIdioma(value);
              }}
              disabled={!isAdmin}
            >
              <option value="">Seleccione una opción</option>
              <option value="Español">Español</option>
              <option value="Inglés">Inglés</option>
              <option value="Francés">Francés</option>
              <option value="Catalán">Catalán</option>
              <option value="Otros">Otros</option>
            </select>
          </div>
        </div>

        <div className="form-row mt-2">
          <div className="col">
            <small>Ciudad</small>
            <input
              type="text"
              className="form-control"
              placeholder="Ciudad"
              value={ciudad}
              onChange={({ target: { value } }) => {
                setCiudad(value);
              }}
              readOnly={!isAdmin}
            />
          </div>

          <div className="col">
            <small>Estado</small>
            <select
              className="form-control input"
              value={estado}
              onChange={({ target: { value } }) => {
                setEstado(value);
              }}
              disabled={!isAdmin}
            >
              <option value="">Seleccione una opción</option>
              <option value="opcion1">Opción 1</option>
              <option value="opcion2">Opción 2</option>
              <option value="opcion3">Opción 3</option>
            </select>
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Url</small>
            <input
              type="text"
              className="form-control"
              placeholder="Url"
              value={url}
              onChange={({ target: { value } }) => {
                setUrl(value);
              }}
              readOnly={!isAdmin}
            />
          </div>
          <div className="col">
            <small>Bib materias</small>
            <input
              type="text"
              className="form-control"
              placeholder="Bib materias"
              value={bibMaterias}
              onChange={({ target: { value } }) => {
                setBibMaterias(value);
              }}
              readOnly={!isAdmin}
            />
          </div>
          <div className="col">
            <small>Año</small>
            <input
              type="text"
              className="form-control"
              placeholder="Año"
              value={anyo}
              onChange={({ target: { value } }) => {
                setAnyo(value);
              }}
              readOnly={!isAdmin}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col-6">
            {(!isCreate && isAdmin) || exists ? (
              <>
                <small>Serie libro</small>
                <select
                  className="form-control input"
                  value={serieLibroId}
                  onChange={({ target: { value } }) => {
                    setSerieLibroId(value);
                  }}
                  disabled={!isAdmin}
                >
                  <option value={null}>Seleccione</option>
                  {isAdmin
                    ? serieLibros?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.observaciones}
                        </option>
                      ))
                    : serieLibros?.map((c) => (
                        <option key={c?.id} value={c?.id}>
                          {c.observaciones}
                        </option>
                      ))}
                </select>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Isbn</small>
            <input
              type="text"
              className="form-control"
              placeholder="Isbn"
              value={isbn}
              onChange={({ target: { value } }) => {
                setIsbn(value);
              }}
              readOnly={!isAdmin}
            />
          </div>
          <div className="col">
            <small>Número registro</small>
            <input
              type="text"
              className="form-control"
              placeholder="Número registro"
              value={numeroRegistro}
              onChange={({ target: { value } }) => {
                setNumeroRegistro(value);
              }}
              readOnly={!isAdmin}
            />
          </div>
          <div className="col">
            <small>Signatura</small>
            <input
              type="text"
              className="form-control"
              placeholder="Signatura"
              value={signatura}
              onChange={({ target: { value } }) => {
                setSignatura(value);
              }}
              readOnly={!isAdmin}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
